import {
    type IPublicClientApplication,
    type AccountInfo,
    InteractionRequiredAuthError,
} from '@azure/msal-browser';
import type { AdminEnv } from '../env';
import { adminTokenRequest } from './msal-config';

export type AcquireToken = () => Promise<string>;

/**
 * Builds an async accessor that returns a fresh Entra access token for the Admin
 * API. Tries silent acquisition first (uses the cached refresh artifact); on
 * `InteractionRequiredAuthError` it falls back to a redirect so the operator can
 * re-consent. Relay's fetch calls this before every request.
 */
export function createAccessTokenProvider(
    instance: IPublicClientApplication,
    account: AccountInfo,
    env: AdminEnv,
): AcquireToken {
    const request = { ...adminTokenRequest(env), account };
    return async () => {
        try {
            const result = await instance.acquireTokenSilent(request);
            return result.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect(request);
                // Redirect navigates away; this rejection is never surfaced to the UI.
                throw new Error('Interaction required — redirecting to sign in.');
            }
            throw error;
        }
    };
}
